import { useEffect } from 'react';
import { FormikContextType, useFormikContext } from 'formik';

export interface FormikFieldWatcherProps<T> {
  keys: string[];
  onFormChange: (formikContext: FormikContextType<T>) => void;
}

const FormikFieldWatcher = <T,>({ keys, onFormChange }: FormikFieldWatcherProps<T>) => {
  const formikContext = useFormikContext<T>();

  const fieldsToWatch = keys.map((key) => formikContext.getFieldMeta(key).value);

  useEffect(() => {
    onFormChange(formikContext);
  }, fieldsToWatch);

  return null;
};

export default FormikFieldWatcher;
